import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import BottomSheet from './BottomSheet';
import ComboBottomSheet from '../../Scripts/WorkStop/ui/ComboBottomSheet';
import { Button } from '../MUIs';
import { useSelector } from 'react-redux';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';

const gubunComboData = [
  { name: '작업을 안전히 종료했습니다.', value: '0' },
  { name: '위험요인 제보.', value: '1' },
  { name: '아차사고 제보.', value: '2' },
];

const DEFAULT_REASON_TEXT = gubunComboData[0].name; // 기본값 세팅

export default function WorkEndBottomStheet({
  SaveLogic4,
  setWorkEndInputs,
  workEndInputs,
  workEndUpload,
}) {
  const [reasonValue, setReasonValue] = useState('0');
  const [isComboOpen, setIsComboOpen] = useState(false);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { riskWorkerOpinionMenuActive } = useSelector((state) => state.homeInfo);
  const { navigate } = useAppNavigate();
  useEffect(() => {
    if (bottomSheetState.bottom === true) {
      setReasonValue('0');
      setIsComboOpen(false);
      // 기본값을 workEndInputs에 반영 (체인지 없이 완료 시 검증/저장용)
      setWorkEndInputs((prev) => ({
        ...prev,
        beforeComment: DEFAULT_REASON_TEXT,
      }));
    }
  }, [bottomSheetState.bottom, setWorkEndInputs]);

  return (
    <BottomSheet
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          작업을 종료합니다.
        </Typography>
      }
    >
      <Box sx={{ px: 1, minHeight: isComboOpen ? '220px' : 'auto' }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          작업 종료 사유가 있다면 선택 후 <br /> 내용을 작성해주세요
        </Typography>

        {/* 콤보박스 */}
        <Box
          sx={{
            marginBottom: '16px',
            height: 'auto',
          }}
        >
          <label
            style={{ fontWeight: 'bold', fontSize: '16px', color: '#2c2c2cff' }}
          >
            작업 종료 사유
          </label>
          <Box onClick={() => setIsComboOpen(!isComboOpen)}>
            <ComboBottomSheet
              items={gubunComboData}
              value={reasonValue}
              onChange={(val) => {
                setReasonValue(val);
                setIsComboOpen(false);
                setWorkEndInputs((prev) => ({
                  ...prev,
                  beforeComment:
                    val === '0'
                      ? DEFAULT_REASON_TEXT
                      : (prev.beforeComment ?? ''),
                }));
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          position: 'sticky',
          bottom: 0,
        }}
      >
        <Button
          guard="request"
          name={
            reasonValue === "0"
              ? "완료"
              : reasonValue === "1"
                ? "위험 요인 제보 작성하기"
                : "아차 사고 제보 작성하기"
          }
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={() => {
            if (reasonValue === "0") {
              return SaveLogic4();
            } else if (reasonValue === "1") {
              riskWorkerOpinionMenuActive
                ? navigate('/M_RNM/write/risk', { state: { workEndYn: 'Y' } })
                : navigate('/M_WorkInfo/write/risk', { state: { workEndYn: 'Y' } });
            } else if (reasonValue === "2") {
              riskWorkerOpinionMenuActive
                ? navigate('/M_RNM/write/nearMiss', { state: { workEndYn: 'Y' } })
                : navigate('/M_WorkInfo/write/nearMiss', { state: { workEndYn: 'Y' } });
            }
          }}
        />
      </Box>
    </BottomSheet>
  );
}
